<template>
    <base-modal hide-header hide-footer @close="$emit('close')" size="lg">
        <div class="col-12 nopads">
            <div class="col-sm-12 editor-form">
                <h2 class="editor-header">
                    {{ $t('work_assignment.edit_multiple') }}
                </h2>
                <span class="hint-text">{{ $t('work_assignment.bulk_edit_hint') }}</span>

                <div class="row mt-2">
                    <div class="col-sm-3">
                        <span class="span-title">{{ $t('work_assignment.select_status') }}</span>
                        <select
                            id="status"
                            v-model="status"
                            class="form-select form-select-sm"
                        >
                            <option :value="null">
                                {{ $t('work_assignment.select_status') }}
                            </option>
                            <option
                                v-for="option in getStatus(false)"
                                :key="option.status"
                                :value="option.status"
                            >
                                {{ option.key }}
                            </option>
                        </select>
                    </div>
                </div>


                <div class="col-sm-12 text-end mt-3 pt-2">
                    <button class="btn btn-secondary form-button" @click.stop="$emit('close')">
                        {{ $t('common.cancel') }}
                    </button>
                    <button
                        :disabled="loading"
                        class="btn btn-success form-button"
                        @click.stop="submitBulkUpdate"
                    >
                        {{ $t('common.save') }}
                    </button>
                </div>
            </div>
            <div
                v-if="loading"
                id="loader"
                class="spinner"
            />
        </div>
    </base-modal>
</template>

<script>
import {restApi} from '../mixins/RestApiMixin'
import {workAssignmentHelper} from '../mixins/WorkAssignmentMixin.js'
import BaseModal from '../BaseModal'
import {timeUtils} from "@/components/mixins/TimeUtils"
import {inject} from "vue"

export default {
    name: 'WorkAssignmentBulkMapEditor',
    components: {BaseModal},
    mixins: [restApi, timeUtils, workAssignmentHelper],
    props: {
        assignments: {
            type: Array,
            default: () => []
        }
    },
    emits: ['close', 'closeAndUpdate'],
    setup() {
        const showAlert = inject('showAlert')
        return { showAlert }
    },
    data() {
        return {
            loading: false,
            contract: null,
            status: null,
            priority: null,
            assignedCompany: null,
            assignee: null,
            contractors: [],
            users: []
        }
    },
    computed: {
        now() {
            return new Date().toISOString()
        }
    },
    methods: {
        submitBulkUpdate() {
            this.loading = true
            let params = {
                assignments: this.assignments.map(a => a.id)
            }
            if (this.status) {
                params.status = this.status
            }
            this.restAdd(this.workAssignmentsUrl, params, this.success, this.fail)
        },
        success() {
            this.loading = false
            this.$emit('closeAndUpdate')
        },
        fail() {
            this.loading = false
            this.showAlert(this.$t('common.alert_update_failed'))
        }
    }
}
</script>
<style>
@import "../../styles/modal.css";
</style>
